import styled from "@emotion/styled";
import LoadingButton from "@mui/lab/LoadingButton";

export const SaveButton = styled(LoadingButton)`
  width: 3.5rem;
  background: #1f8feb;
  color: #fff;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0.45rem 0.45rem;
  border: none;
  border-radius: 1.5rem;
  cursor: pointer;
  text-transform: none;
  height: 1.8rem;
  min-width: 60px;
  min-height: 25px;
`;
export const CancelButton = styled.button`
  width: 3.5rem;
  background: transparent;
  color: #aaa;
  font-size: 0.7rem;
  padding: 0.45rem 0.45rem;
  border: 1px solid #aaa;
  border-radius: 1.5rem;
  cursor: pointer;
  height: 1.8rem;
  line-height: 0;
  letter-spacing: 0.02857em;
  min-width: 60px;
  min-height: 25px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 0.5rem;
  padding: 0 10px;
  width: 85%;
`;
